// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1Hloy","dragIcon":"Choice_dragIcon__Z3vKX","left":"Choice_left__3moGB","input":"Choice_input__3xOUX"};